<script >

import bem from '@/utils/bem';
import PreviewHintHelpCenter from '@/pages/helpCenter/previewHintHelpCenter/Preview-hint-help-center.vue';
import ModalWrapper from '@/components/modals/Modal-wrapper.vue';
import { DownOutlined, UpOutlined } from '@ant-design/icons-vue';

const b = bem('help-center-hint');

export default {
  components: {
    UpOutlined,
    DownOutlined,
    ModalWrapper,
    PreviewHintHelpCenter,
  },
  props: {
    hint: {
      type: Object,
      required: true,
    },
    isFirst: {
      type: Boolean,
    },
    isLast: {
      type: Boolean,
    },
    changeOrder: {
      type: Function,
    },
    onDelete: {
      type: Function,
    },
    onEdit: {
      type: Function,
    },
    withCreatedLink: {
      type: Boolean,
      default: false,
    },
    copyLinkToClipboard: {
      type: Function,
    },
  },
  data() {
    return {
      isShowHelpCenterPreviewPopup: false,
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    openPreviewWindow() {
      this.isShowHelpCenterPreviewPopup = true;
    },
  },
};
</script>

<template>
  <div :class="b('')">
    <div :class="b('title')">{{ hint.title }}</div>
    <button
      :class="b('get-link')"
      v-if="withCreatedLink"
      @click="() => copyLinkToClipboard(hint)"
    >
      Get link
    </button>
    <a-button
      type="primary"
      html-type="button"
      @click="openPreviewWindow()"
    >
      Open preview
    </a-button>
    <modal-wrapper
      v-model:show="isShowHelpCenterPreviewPopup"
      width="1367px"
    >
      <preview-hint-help-center
        :hint="hint"
      />
    </modal-wrapper>
    <div :class="b('actions')">
      <a-button
        :class="b('order-button-up')"
        v-if="!isFirst"
        type="primary"
        html-type="button"
        @click="() => changeOrder('up')"
      >
        <template #icon>
          <UpOutlined />
        </template>
      </a-button>
      <a-button
        v-if="!isLast"
        type="primary"
        html-type="button"
        @click="() => changeOrder('down')"
      >
        <template #icon>
          <DownOutlined />
        </template>
      </a-button>
    </div>
    <div :class="b('actions')">
      <a-button
        type="primary"
        html-type="button"
        @click="onEdit"
      >
        Edit
      </a-button>
      <a-button
        type="primary"
        html-type="button"
        danger
        @click="onDelete"
      >
        Delete
      </a-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import '@/styles/variables';
  @import "@/styles/media";

  .help-center-hint {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 100px;
    height: 90px;
    box-shadow: 10.1px 12.4px 76px 0 rgba(0,0,0,.07);
    background-color: #fff;
    padding: 10px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(100);
    }

    &__title {
      flex-grow: 1;
    }

    &__actions {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    &__get-link {
      display: flex;
      border: none;
      color: $tacao;
      background: $ebony-clay-gray-color;
      text-transform: uppercase;
      padding: 10px 15px;
      border-radius: 5px;

      @include mediaMinMax(1025, $normal) {
        padding: vw-full(5);
        border-radius: vw-full(5);
      }
    }
  }
</style>
